var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import { DataLocationComponentConstants } from "../../../../constants/DataSource.constants.js";
import { TextField } from "@ane/ui-components";
const getAAStreamLocationPrefixFields = (formikProps, isReadOnly = false) => {
  const currentValue = formikProps.values.aaStreamConfig.LocationPrefix;
  const onChange = (_, value) => {
    var _a;
    let aaStreamConfig = __spreadProps(__spreadValues({}, (_a = formikProps == null ? void 0 : formikProps.values) == null ? void 0 : _a.aaStreamConfig), { LocationPrefix: value });
    formikProps == null ? void 0 : formikProps.setFieldValue("aaStreamConfig", aaStreamConfig, true);
  };
  const getErrorMsg = (value) => {
    if (!value) {
      return "";
    }
    const relativePathPattern = /^\/[^\/\\:?#]+(\/[^\/\\:?#]*)*$/;
    return relativePathPattern.test(value) ? "" : DataLocationComponentConstants.AAStreamLocationPrefixField.errorMsg;
  };
  return /* @__PURE__ */ jsx(
    TextField,
    {
      name: DataLocationComponentConstants.AAStreamLocationPrefixField.name,
      label: DataLocationComponentConstants.AAStreamLocationPrefixField.label,
      required: false,
      ariaLabel: DataLocationComponentConstants.AAStreamLocationPrefixField.label,
      description: DataLocationComponentConstants.AAStreamLocationPrefixField.description,
      errorMessage: getErrorMsg(currentValue != null ? currentValue : ""),
      value: currentValue || "",
      onChange,
      disabled: isReadOnly
    }
  );
};
const getAAStreamExpiryDaysField = (formikProps, isReadOnly = false) => {
  const onChange = (_, value) => {
    var _a;
    let aaStreamConfig = __spreadProps(__spreadValues({}, (_a = formikProps == null ? void 0 : formikProps.values) == null ? void 0 : _a.aaStreamConfig), { ExpiryDays: value });
    formikProps == null ? void 0 : formikProps.setFieldValue("aaStreamConfig", aaStreamConfig, false);
  };
  return /* @__PURE__ */ jsx(
    TextField,
    {
      name: DataLocationComponentConstants.AAStreamExpirationDateField.name,
      label: DataLocationComponentConstants.AAStreamExpirationDateField.label,
      required: false,
      type: "number",
      ariaLabel: DataLocationComponentConstants.AAStreamExpirationDateField.label,
      description: DataLocationComponentConstants.AAStreamExpirationDateField.description,
      value: formikProps.values.aaStreamConfig.ExpiryDays.toString(),
      disabled: isReadOnly,
      onChange
    }
  );
};
export {
  getAAStreamExpiryDaysField,
  getAAStreamLocationPrefixFields
};
//# sourceMappingURL=DataLocationFieldConfig.js.map
